var exports = {
  "i": "xaee3c4fa--ecd299--wrapper",
};

module.exports = exports;
